import React from "react";
import ReactDOM from "react-dom/client";
// 导入首页组件
import Homepage from "./Homepage-TW/Homepage";
// 从 react-router-dom 中引入路由相关的 API
import { RouterProvider, createBrowserRouter } from "react-router-dom";

// 导入认证相关组件
import Login from "./Homepage-TW/components/Auth/Login";
import Signup from "./Homepage-TW/components/Auth/Signup";
import ForgotPassword from "./Homepage-TW/components/Auth/ForgotPassword";
import Dashboard from "./Homepage-TW/components/Auth/Dashboard";
import PrivateRoute from "./Homepage-TW/components/Auth/PrivateRoute";
import NoFoundPage from "./Homepage-TW/components/Auth/NoFoundPage";

// 导入表单组件
// import FormRegisterCN from "./Homepage-TW/components/Forms/FormRegisterCN";
import FormRegister from "./Homepage-TW/components/Forms/FormRegister";
// import FormEmail from "./Homepage-TW/components/Forms/FormEmail";


// 导入认证上下文提供者
import { AuthProvider } from "./Homepage-TW/contexts/AuthContext";

// 导入各个签名页组件
import Signature1 from "./Homepage-TW/components/Signature/Signature1";
import Signature2 from "./Homepage-TW/components/Signature/Signature2";
import Signature3 from "./Homepage-TW/components/Signature/Signature3";
import Signature4 from "./Homepage-TW/components/Signature/Signature4";
import Signature5 from "./Homepage-TW/components/Signature/Signature5";
import Signature6 from "./Homepage-TW/components/Signature/Signature6";
import Signature7 from "./Homepage-TW/components/Signature/Signature7";
import Signature8 from "./Homepage-TW/components/Signature/Signature8";
import Signature9 from "./Homepage-TW/components/Signature/Signature9";
import Signature10 from "./Homepage-TW/components/Signature/Signature10";
import Signature11 from "./Homepage-TW/components/Signature/Signature11";
import Signature12 from "./Homepage-TW/components/Signature/Signature12";

// 创建路由配置
// 只有首页 ("/")、登录页面 ("/login") 和注册页面 ("/signup") 对未登录用户开放，其它页面均由 PrivateRoute 保护
const router = createBrowserRouter([
  {
    path: "/",
    // 根路径加载 Homepage，并提供认证上下文
    element: (
      <AuthProvider>
        <Homepage />
      </AuthProvider>
    ),
    // 错误路由，当路径不匹配时显示 NoFoundPage
    errorElement: <NoFoundPage />,
  },
  {
    path: "/login",
    // 登录页面
    element: (
      <AuthProvider>
        <Login />
      </AuthProvider>
    ),
  },
  {
    path: "/signup",
    // 注册页面
    element: (
      <AuthProvider>
        <Signup />
      </AuthProvider>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <AuthProvider>
        <ForgotPassword />
      </AuthProvider>
    ),
  },
  // 签名页路由配置（如 Signature1 ~ Signature12）
  // 以下所有路由均需要用户登录才能访问
  {
    path: "/signature1",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature1 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature2",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature2 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature3",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature3 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature4",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature4 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature5",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature5 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature6",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature6 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature7",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature7 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature8",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature8 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature9",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature9 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature10",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature10 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature11",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature11 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  {
    path: "/signature12",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Signature12 />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
  // 表单注册页面
  {
    path: "/formReg",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <FormRegister />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
//登机后自动回复邮件
  // {
  //   path: "/formReg",
  //   element: (
  //     <AuthProvider>
  //       <PrivateRoute>
  //         <FormEmail />
  //       </PrivateRoute>
  //     </AuthProvider>
  //   ),
  // },
  // 认证相关路由：登录、注册、重置密码、仪表盘

  {
    path: "/dashboard",
    element: (
      <AuthProvider>
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      </AuthProvider>
    ),
  },
]);

// 获取根 DOM 元素并创建 React 根实例
const root = ReactDOM.createRoot(document.getElementById("root"));

// 使用 React.StrictMode 包裹应用，有助于在开发环境下检测潜在问题
root.render(
  <React.StrictMode>
    {/* 使用 RouterProvider 提供路由配置 */}
    <RouterProvider router={router} />
  </React.StrictMode>
);